import { useCallback, useEffect, useRef, useState } from 'react'

import { useParams } from 'react-router-dom'
import { toast } from 'react-toastify'

import { FormProdutos } from '../../components/Forms/FormProdutos'

import EstruturasService from '../../services/database/EstruturasService'
import ProdutosFilhosService from '../../services/database/ProdutosFilhosService'
import ProdutosService from '../../services/database/ProdutosService'
import { sendErrorApiMessage } from '../../utils/sendErrorApiMessage'

export function EditarProduto() {
  const [product, setProduct] = useState({})
  const [isLoadingProduct, setIsLoadingProduct] = useState(true)
  const [isUpdateProductLoading, setIsUpdateProductLoading] = useState(false)

  const formProdutosRef = useRef(null)

  const params = useParams()

  async function handleSubmit(e) {
    e.preventDefault()

    try {
      setIsUpdateProductLoading(true)

      if (formProdutosRef.current) {
        const { product, children, composicoes } =
          formProdutosRef.current?.getProduct()

        if (
          product.DESCRICAO === '' ||
          product.ID_CATEGORIA === '' ||
          product.ID_SUBCATEGORIA === '' ||
          product.MARCA === '' ||
          product.PRECOCUSTO === '0' ||
          product.PRECOVENDA === '0'
        ) {
          return toast.error('Existem campos obrigatórios a serem preenchidos!')
        }

        if (children && children.length > 0) {
          await ProdutosFilhosService.create(children, localStorage.idusuario)
        }

        if (composicoes && composicoes.length > 0) {
          await EstruturasService.create(composicoes)
        }

        await ProdutosService.update(params.idProduto, product)

        toast.success('Produto atualizado com sucesso!')
        loadProduct()
      }
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível atualizar o produto!')
    } finally {
      setIsUpdateProductLoading(false)
    }
  }

  const loadProduct = useCallback(async () => {
    try {
      setIsLoadingProduct(true)

      const { idProduto } = params

      const productData = await ProdutosService.getById(idProduto)

      setProduct(productData)
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível buscar o produto!')
    } finally {
      setIsLoadingProduct(false)
    }
  }, [params])

  useEffect(() => {
    loadProduct()
  }, [loadProduct])

  return (
    <FormProdutos
      ref={formProdutosRef}
      isEditPage
      productToEdit={product}
      titlePage={`Editar Produto #${params.idProduto}`}
      onSubmit={handleSubmit}
      isRequestLoading={isUpdateProductLoading}
      isLoadingProduct={isLoadingProduct}
      loadProduct={loadProduct}
    />
  )
}
